const cartEvents = ['cart:change', 'cart:update', 'cart:render'];

const moneyFormat = (amount) => {
    return `${ (amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }`;
}

const fetchCart = async () => {
    try {
      const res = await fetch('/cart.js');
      const data = await res.json();
      if (res.ok) return data;
    } catch (error) {
      console.log(error);
      return null
    }
}

const addProductToCart = (id, gwpTier) => {
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    let formData = {
        'items': [{
            'id': id,
            'quantity': 1
        }],
        'sections': cart.getSectionsToRender().map((section) => section.id),
        'sections_url': window.location.pathname
    };
    if(gwpTier) {
        formData.items[0].properties = {
            '_gwp_tier': gwpTier
        };
    }
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then((response) => response.json())
    .then(response => {
        cart.renderContents(response);
        if(gwpTier) {
            document.querySelector(`.gwp-drawer[data-gwp-tier="${gwpTier}"]`).classList.remove('active');
        }
        return response;
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}

 // Quick Add variant select update ATC button
const quickAddSelectors = () => {
    const quickAddSelect = document.querySelectorAll('.js-quick-add-available');
    if(quickAddSelect.length) {
        quickAddSelect.forEach(container => {
            const variantSelect = container.querySelectorAll('.variant-wrapper select');
            variantSelect.forEach(select => {
                select.addEventListener('change', (e) => {
                    const parent = e.target.closest('.js-quick-add-available');
                    const selectedOptionName = e.target.value;
                    const selectedOption = parent.querySelector(`option[value="${selectedOptionName}"]`);
                    const variantId = selectedOption.getAttribute('data-variant-id');
                    const atcBtn = parent.querySelector('.js-quick-add-to-cart');
                    atcBtn.setAttribute('data-id', variantId);
                })
            })
        })
    }
}

// Show GWP
const gwpButtons = () => {
    const showGwpBtn = document.querySelectorAll('.js-show-gwp');
    if(showGwpBtn.length) {
        showGwpBtn.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const targetId = e.target.getAttribute('data-gwp-tier');
                const gwpDrawer = document.querySelector(`.gwp-drawer[data-gwp-tier="${targetId}"]`);
                gwpDrawer.classList.add('active');
            })
        })
    }
    const closeGwpBtn = document.querySelectorAll('.gwp-drawer .drawer__close');
    if(closeGwpBtn.length) {
        closeGwpBtn.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const gwpDrawer = e.target.closest('.gwp-drawer');
                gwpDrawer.classList.remove('active');
            });
        })
    }
}

// Free gift with purchase
const initFreeGiftWithPurchase = async (productGroup1, threshold1, productGroup2, threshold2, productGroup3, threshold3) => {
    if (!productGroup1 && !productGroup2 && !productGroup3) return;
    let hasMetafields = false;
    threshold1 = threshold1 * Shopify.currency.rate;
    threshold2 = threshold2 * Shopify.currency.rate;
    threshold3 = threshold3 * Shopify.currency.rate;
    productGroup1.forEach(product => {
        if(product.metafieldThreshold != 0) {
            hasMetafields = true;
        }
    });
    productGroup2.forEach(product => {
        if(product.metafieldThreshold != 0) {
            hasMetafields = true;
        }
    });
    productGroup3.forEach(product => {
        if(product.metafieldThreshold != 0) {
            hasMetafields = true;
        }
    });
    if(!hasMetafields) return;

    const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  
    const removeFreeGift = (key) => {
        if (!key) return;

        let formData = {
            'id': key,
            'quantity': 0,
            'sections': cartEl.getSectionsToRender().map((section) => section.id),
            'sections_url': window.location.pathname
        };
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then((response) => response.json())
        .then(response => {
            cartEl.renderContents(response);
            return response;
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    
    }

    const addOrRemoveFreeGift = (remaining, productInCart, gwpTier) => {
        const tierBtn = document.querySelector(`.js-show-gwp[data-gwp-tier="${gwpTier}"]`);
        if (remaining <= 0 ) {
            if(productInCart.length == 0) {
                if(tierBtn) {
                    tierBtn.style.display = "block";
                }
            } else if(productInCart.length > 1) {
                productInCart.forEach((product, index) => {
                    if(index > 0) {
                        removeFreeGift(product.key);
                    }
                });
                if(tierBtn) {
                    tierBtn.style.display = "none";
                }
            } else {
                if(tierBtn) {
                    tierBtn.style.display = "none";
                }
            }
        } else {
            if(tierBtn) {
                tierBtn.style.display = "none";
            }
            if (productInCart.length > 0) {
                productInCart.forEach((product) => {
                    removeFreeGift(product.key);
                });
            }
        }
    }
  
    const checkCart = async (cart) => {
        if (!cart) return;
        const { items, total_price } = cart;
        if (!items.length) return;
        const cartTotal = total_price / 100;

        if(productGroup1.length > 0) {
            let productInCart = items.filter(({ product_id, variant_id, properties }) => {
                return properties["_gwp_tier"] == "1"
            });
            let remaining = threshold1 - cartTotal;
            addOrRemoveFreeGift(remaining, productInCart, 1)
        }

        if(productGroup2.length > 0) {
            let productInCart = items.filter(({ product_id, variant_id, properties }) => {
                return properties["_gwp_tier"] == "2"
            });
            let remaining = threshold2 - cartTotal;
            addOrRemoveFreeGift(remaining, productInCart, 2)
        }

        if(productGroup3.length > 0) {
            let productInCart = items.filter(({ product_id, variant_id, properties }) => {
                return properties["_gwp_tier"] == "3"
            });
            let remaining = threshold3 - cartTotal;
            addOrRemoveFreeGift(remaining, productInCart, 3)
        }

    }

    cartEvents.forEach(e => {
        document.addEventListener(e, async () => {
            const cart = await fetchCart();
            checkCart(cart);
        });
    })

    document.addEventListener('DOMContentLoaded', async () => {
        const cart = await fetchCart();
        checkCart(cart);
    });
    
}

const upsellSliderShowHide = () => {
    const upsell = document.querySelector('#Slider-cartupsell');
    if(upsell) {
        const items = upsell.querySelectorAll('li');
        if(items.length == 0) {
            const parent = upsell.closest('.cart-upsell-slider');
            parent.style.display = "none";
        }
    }
}

if ((window.themeSettings.freeGiftProductGroup1.length > 0 && window.themeSettings.freeGiftThreshold1 != 0) || (window.themeSettings.freeGiftProductGroup2.length > 0 && window.themeSettings.freeGiftThreshold2 != 0) || (window.themeSettings.freeGiftProductGroup3.length > 0 && window.themeSettings.freeGiftThreshold3 != 0)) {
    initFreeGiftWithPurchase(window.themeSettings.freeGiftProductGroup1, window.themeSettings.freeGiftThreshold1, window.themeSettings.freeGiftProductGroup2, window.themeSettings.freeGiftThreshold2, window.themeSettings.freeGiftProductGroup3, window.themeSettings.freeGiftThreshold3 );
}

const quickAddPlp = () => {
    const quickAddBtns = document.querySelectorAll('.card__size-selector .card-size__value');
    if(quickAddBtns.length) {
        quickAddBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                let variantId =  e.target.getAttribute('data-variant-id');
                addProductToCart(variantId);
            })
        })
    }
}

const reinitQuickAddPlp = (container) => {
    const new_quickAddBtns = container.querySelectorAll('.card__size-selector .card-size__value');
    if(new_quickAddBtns.length) {
        new_quickAddBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                let variantId =  e.target.getAttribute('data-variant-id');
                addProductToCart(variantId);
            })
        })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    quickAddSelectors();
    gwpButtons();
    upsellSliderShowHide();
    quickAddPlp();
});

window.addEventListener('productCardsLoaded', () => {
    quickAddPlp();
});

cartEvents.forEach(event => {
    document.addEventListener(event, quickAddSelectors);
    document.addEventListener(event, gwpButtons);
    document.addEventListener(event, upsellSliderShowHide);
})

document.addEventListener("scroll", (e) => {
    let currentPos = window.scrollY;
    const header = document.querySelector('.header');
    if(currentPos > 50) {
        header.classList.add('scrolled');
    } else {
        header.classList.remove('scrolled');
    }
});


window.addEventListener('DOMContentLoaded', () => {
    // PLP COLOUR SWATCHES
    $(document).on('click', '.colour-swatches--card-product .colour-swatches__swatch-btn', (e) => {
        const swatch = e.currentTarget;

        // Get data
        const title = swatch.dataset.title;
        const id = swatch.dataset.id;
        const url = swatch.dataset.url;
        const price = swatch.dataset.price;
        const compareAtPrice = swatch.dataset.compareAtPrice;
        const primaryImg = swatch.dataset.primaryImg;
        const secondaryImg = swatch.dataset.secondaryImg;
        const options = JSON.parse(swatch.dataset.options);
        const variants = JSON.parse(swatch.dataset.variants);
        const shortDesc = swatch.dataset.shortDescription;

        // Get elements
        const parent = swatch.closest('.card');
        const url_elem_1 = parent.querySelector('a.card__media-link');
        const url_elem_2 = parent.querySelector('.card__heading a');
        const img_elem = parent.querySelector('.card__media .media');
        const title_elem = parent.querySelector('.card__heading a');
        const price_elems = parent.querySelectorAll('.card__price .price-item--regular');
        const compareAtPrice_elems = parent.querySelectorAll('.card__price .price-item--sale');
        const sizes_elem = parent.querySelector('.card__size-selector');
        const short_desc_elem = parent.querySelector('.product-short-description');

        // Update title
        if (title_elem) {
            title_elem.innerHTML = title;
        }

        // Update images
        if (img_elem) {
            img_elem.innerHTML = `
                <img src="${primaryImg}" alt="" class="loaded" />
                <img src="${secondaryImg}" alt="" class="loaded" />
            `;
        }

        // Update prices
        if (compareAtPrice && parseInt(compareAtPrice) > parseInt(price)) {
            if (price_elems) {
                price_elems.forEach(elem => {
                    elem.innerHTML = '$' + moneyFormat(parseInt(compareAtPrice) / 100);
                });
            }
            if (compareAtPrice_elems) {
                compareAtPrice_elems.forEach(elem => {
                    elem.innerHTML = '$' + moneyFormat(parseInt(price) / 100);
                });
            }
        } else {
            if (price_elems) {
                price_elems.forEach(elem => {
                    elem.innerHTML = '$' + moneyFormat(parseInt(price) / 100);
                });
            }
        }

        // Update links
        if (url_elem_1) {
            url_elem_1.setAttribute('href', url);
        }
        if (url_elem_2) {
            url_elem_2.setAttribute('href', url);
        }

        // Update variants
        let index = 0;
        for (let i = 0; i < options.length; i++) {
            let opt = options[i].toLowerCase();
            if (opt.includes('size')) {
                index = i+1;
                break;
            }
        }
        if(short_desc_elem) {
            short_desc_elem.innerHTML = shortDesc;
        }
        if (sizes_elem) {
            let btnData = '';
            if (index > 0) {
                let opt = `option${index}`;
                for (let i = 0; i < variants.length; i++) {
                    btnData += `
                        <button type="button" class="size-add-to-cart card-size__value${variants[i].available ? '' : ' disabled'}" data-variant-id="${variants[i].id}"${variants[i].available ? '' : ' disabled'}>${variants[i][opt]}</button>
                    `;
                }
            } else {
                for (let i = 0; i < variants.length; i++) {
                    btnData += `
                        <button type="button" class="size-add-to-cart card-size__value${variants[i].available ? '' : ' disabled'}" data-variant-id="${variants[i].id}"${variants[i].available ? '' : ' disabled'}>${variants[i].title}</button>
                    `;
                }
            }
            
            sizes_elem.innerHTML = btnData;

            reinitQuickAddPlp(sizes_elem);
        }

        // Update wishlist
        const wishlist_elem = parent.querySelector('.swym-button');
        wishlist_elem.setAttribute('data-product-id', id);
        wishlist_elem.setAttribute('data-variant-id', variants[0].id);
        const wishlistId = 'wishlist-' + id + Date.now();
        parent.setAttribute("id", wishlistId);
        document.dispatchEvent(new CustomEvent("swatch-wishlist-update", {detail: wishlistId}));
    })

    // TOGGLE SIZE SELECTOR
    $(document).on('click', '.card__toggle-size-selector', (e) => {
        e.preventDefault();
        const btn = e.currentTarget;
        const parent = btn.closest('.card');
        const sizes = parent.querySelector('.card__size-selector')

        btn.style.display = 'none';

        sizes.classList.add('visible');
    })
})

document.addEventListener('DOMContentLoaded', () => {
    // Calc header size
    const calcHeaderSize = () => {
        const header = document.querySelector('.header');
        if(header) {
            const height = header.offsetHeight;
            document.body.style.setProperty('--headerHeight', `${height}px`);
        }
    }

    calcHeaderSize();

    document.addEventListener("resize", calcHeaderSize);
})

document.addEventListener("click", (event) => { 
    const target = event.target;

    if(target.classList.contains('js-quick-add-to-cart')) {
        event.preventDefault();
        if (target.hasAttribute('disabled')) {
            return;
        }
        let gwpTier = target.getAttribute('data-gwp-tier');
        let id = target.getAttribute('data-id');
        addProductToCart(id, gwpTier);
    }
})